<template>
  <div class="date bg-l-black cp">
    <div class="title size18" v-if="title">{{ title }}</div>
    <div class="header flex-b-c size18">
      <div class="flxL">
        <a-space :size="10"
          ><span>{{ getYearMonth }}</span
          ><span>{{ getMonthEN }}</span></a-space
        >
      </div>
      <div>
        <a-space :size="15">
          <i class="el-icon-arrow-left" style="font-size: 14px;padding: 10px;" @click="prevMonth"></i>
          <i class="el-icon-arrow-right" style="font-size: 14px;padding: 10px;"  @click="nextMonth"></i>
        </a-space>
      </div>
    </div>
    <div class="dates">
      <div class="week flex size14 txt-white margin-x-auto">
        <span>M</span>
        <span>T</span>
        <span>W</span>
        <span>T</span>
        <span>F</span>
        <span>S</span>
        <span>S</span>
      </div>
      <div class="every-date size14 flex flex-wrap margin-x-auto">
        <span
          :class="{
            active: item.value == current && item.type == 'current',
            noCurrent: item.type != 'current',
          }"
          v-for="(item, index) in getDatesList"
          :key="index"
          @click="changeDate(item)"
          >{{ item.value }}</span
        >
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
    },
    time: {
      type: Date,
    },
  },
  data() {
    return {
      now: null,
      monthEN: {
        0: "January",
        1: "February",
        2: "March",
        3: "April",
        4: "May",
        5: "June",
        6: "July",
        7: "August",
        8: "September",
        9: "October",
        10: "November",
        11: "December",
      },
    };
  },
  computed: {
    // 获取月份英文
    getMonthEN() {
      return this.monthEN[this.now.getMonth()];
    },
    // 获取年月
    getYearMonth() {
      return `${this.now.getFullYear()}.${(this.now.getMonth() + 1)
        .toString()
        .padStart(2, "0")}`;
    },
    // 获取当前date
    current() {
      return this.now.getDate();
    },
    // 格式化
    nowDate() {
      return new Date(this.now.getFullYear(), this.now.getMonth() + 1, 0);
    },
    // 获取当月天数
    getDates() {
      return this.nowDate.getDate();
    },
    // 获取上月天数
    getLastDates() {
      return new Date(this.now.getFullYear(), this.now.getMonth(), 0).getDate();
    },
    // 获取当月第一天是周几
    getFirstDay() {
      return new Date(this.now.getFullYear(), this.now.getMonth(), 1).getDay();
    },
    // 获取当月最后一天是周几
    getLastDay() {
      return new Date(
        this.now.getFullYear(),
        this.now.getMonth(),
        this.getDates
      ).getDay();
    },
    // 格式化每天，凑成7的倍数
    getDatesList() {
      // 正常天数
      const normalDates = Array.from(
        {
          length: this.getDates,
        },
        (ele, index) => ({
          value: index + 1,
          type: "current",
        })
      );
      // 头部日期
      const headNum = this.getFirstDay == 0 ? 6 : this.getFirstDay - 1;
      const neadNullDates = Array.from(
        {
          length: headNum,
        },
        (ele, index) => ({
          value: this.getLastDates - (headNum - index - 1),
          type: "last",
        })
      );
      // 尾部日期
      const nextNullDates = Array.from(
        {
          length: this.getLastDay == 0 ? 0 : 7 - this.getLastDay,
        },
        (ele, index) => ({
          value: index + 1,
          type: "next",
        })
      );
      return neadNullDates.concat(normalDates).concat(nextNullDates);
    },
  },
  methods: {
    // 点击date
    changeDate(item) {
      console.log(item);
      if (item.type == "current") {
        console.log(this.now.getMonth());
        this.setNowValue(
          new Date(this.now.getFullYear(), this.now.getMonth(), +item.value)
        );
      } else if (item.type == "last") {
        this.setNowValue(
          new Date(this.now.getFullYear(), this.now.getMonth() - 1, +item.value)
        );
      } else if (item.type == "next") {
        this.setNowValue(
          new Date(this.now.getFullYear(), this.now.getMonth() + 1, +item.value)
        );
      }
    },
    // 上个月
    prevMonth() {
      this.setNowValue(
        new Date(this.now.getFullYear(), this.now.getMonth() - 1, 1)
      );
    },
    // 下个月
    nextMonth() {
      this.setNowValue(
        new Date(this.now.getFullYear(), this.now.getMonth() + 1, 1)
      );
    },
    setNowValue(val) {
      console.log(val);
      this.now = val;
      this.$emit('update', val);
      // this.$emit('update:time', val);
    },
  },
  watch: {
    time: {
      handler(val) {
        if (val && val instanceof Date && (+val != +this.now)) {
          this.now = val;
        }
      },
      immediate: true,
    },
  },
};
</script>
<style lang='less' scoped>
@cell-size: 36px;
.date {
  width: 380px;
  padding: 32px 24px;
  user-select: none;
  background: #21284B;
  .title {
    font-weight: bold;
    color: white;
    margin-bottom: 32px;
  }
  .dates {
    padding: 10px 0;
    .week {
      span {
        width: @cell-size;
        height: @cell-size;
        color: #ffffff;
        text-align: center;
        line-height: @cell-size;
        margin: 5px;
        box-sizing: content-box;
      }
    }
    .every-date {
      span {
        width: @cell-size;
        height: @cell-size;
        color: #bcbcbc;
        text-align: center;
        margin: 5px;
        line-height: @cell-size;
        box-sizing: content-box;
      }
      .active {
        background: #1890ff;
        border-radius: 50%;
      }
      .noCurrent {
        color: #666666;
      }
    }
  }
}
</style>